import { useTheme } from "@emotion/react";
import { Grid } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useRef } from "react";

import LoaderThreeDots from "../../../../components/loadingAnimation";
import useStyles from "./styles";
import FluxoAtendimentoEtapaComponent from "../../../../components/fluxoAtendimentoEtapaComponent";

export default function FluxoAtendimento(params) {
  const {
    fluxoAtendimento,
    loading,
    setSelectEtapa = () => {},
    selectEtapaFluxo,
    toggleDrawer = () => {},
    windowWidth = null,
    isPropertyColor = false,
    converterMinutos = () => {},
  } = params;

  const theme = useTheme();
  const styles = useStyles(theme);

  // Cria refs dinâmicas para cada item
  const itemRefs = useRef({});

  useEffect(() => {
    if (selectEtapaFluxo?.idEtapaFluxoAtendimento) {
      const selectedRef =
        itemRefs.current[selectEtapaFluxo.idEtapaFluxoAtendimento];
      if (selectedRef) {
        selectedRef.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  }, [selectEtapaFluxo]);

  return (
    <Box sx={styles.boxComponent}>
      {loading ? (
        <LoaderThreeDots />
      ) : (
        <Grid
          container
          spacing={1}
          columns={{ xs: 2, sm: 4, md: 4, lg: 4, xl: 4, xxl: 4 }}
        >
          {fluxoAtendimento?.map((fluxo) => (
            <Grid
              item
              xs={2}
              sm={4}
              md={4}
              lg={4}
              key={fluxo.idEtapaFluxoAtendimento}
              ref={(el) =>
                (itemRefs.current[fluxo.idEtapaFluxoAtendimento] = el)
              }
            >
              <FluxoAtendimentoEtapaComponent
                title={fluxo.etapaFluxoAtendimento}
                color={fluxo.color}
                isPropertyColor={isPropertyColor}
                fluxo={fluxo}
                setSelectEtapa={setSelectEtapa}
                selectEtapaFluxo={selectEtapaFluxo}
                toggleDrawer={toggleDrawer}
                windowWidth={windowWidth}
                converterMinutos={converterMinutos}
                selected={
                  selectEtapaFluxo?.idEtapaFluxoAtendimento ===
                  fluxo?.idEtapaFluxoAtendimento
                }
                timeSla={
                  fluxo?.timeSla ? converterMinutos(fluxo?.timeSla)?.text : null
                }
                timeSlaIdle={
                  fluxo?.timeSlaIdle
                    ? converterMinutos(fluxo?.timeSlaIdle)?.text
                    : null
                }
              />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
}
